module.exports = __webpack_public_path__ + "img/img_krw_close.3969d63.png";